import React, { useState } from "react";
import { GlobalHotKeys } from "react-hotkeys";
import Typography from "@material-ui/core/Typography";

const IndexedKeyListener = ({ arr, onSelected, type }) => {
	const [lastKeys, setLastKeys] = useState([]);
	const arrMap = arr.map((val, i) => ({
		...val,
		keyStroke: `${i + 1}`.length === 1 ? `0${i + 1}` : `${i + 1}`
	}));
	const arrMapLength = `${arrMap.length}`.length;

	// Keystrokes that can automatically transition
	const autoKeys = [];
	arrMap.forEach((val) => {
		const { keyStroke } = val;
		const isManual = arrMap.some(
			(x) => x.keyStroke !== keyStroke && x.keyStroke.startsWith(keyStroke)
		);
		if (!isManual) autoKeys.push(keyStroke);
	});

	const keyMap = {
		TRANSITION: [..."0123456789"],
		MANUAL_TRANSITION: ["enter"],
		CLEAR: ["del"],
		DELETE: ["backspace"]
	};
	const handlers = {
		TRANSITION: (event) => {
			const keyStroke = event.key;
			const updatedLastKeys = [...lastKeys, keyStroke];
			const combinedKeys = updatedLastKeys.join("");
			if (autoKeys.some((ak) => ak === combinedKeys)) {
				const arrIndex = arrMap.findIndex((x) => combinedKeys === x.keyStroke);
				if (arrIndex >= 0) onSelected(arr[arrIndex]);
				setLastKeys([]);
			} else if (
				updatedLastKeys.length >=
				(arrMapLength > 1 ? arrMapLength : arrMapLength + 1)
			)
				setLastKeys([]);
			else setLastKeys(updatedLastKeys);
		},
		MANUAL_TRANSITION: () => {
			const combinedKeys = lastKeys.join("");
			const arrIndex = arrMap.findIndex(
				(x) =>
					combinedKeys ===
					(x.keyStroke[0] === "0" ? x.keyStroke.slice(1) : x.keyStroke)
			);
			if (arrIndex >= 0) onSelected(arr[arrIndex]);
			setLastKeys([]);
		},
		CLEAR: () => {
			setLastKeys([]);
		},
		DELETE: () => {
			setLastKeys(lastKeys.slice(0, lastKeys.length - 1));
		}
	};

	return (
		<>
			<Typography>{`Type the corresponding digit(s) to select a ${type}: ${lastKeys.join(
				""
			)}...`}</Typography>
			<GlobalHotKeys keyMap={keyMap} handlers={handlers} allowChanges />
		</>
	);
};

export default IndexedKeyListener;
